import { LicenseValidationResponse } from '../LicenseValidationService';

export interface ILicenseValidationService {
  validateLicense(license: string, traceId?: string, appId?: string, metadata?: any): Promise<LicenseValidationResponse>;
}
